import { render, staticRenderFns } from "./ProfessionalRegisterEdit.vue?vue&type=template&id=1d772fe3&"
import script from "./ProfessionalRegisterEdit.vue?vue&type=script&lang=js&"
export * from "./ProfessionalRegisterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports